import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import { colorPalette } from "../styles/theme";
import { useState, useRef } from "react";
import { wsApi } from "../api/services";

const InquiryAnswer = ({ user_email, inquiry_title, inquiry_id, selectInquiry, setSelectInquiry, handlePatchStatus }) => {
  const answer_title = "Re: " + inquiry_title
  const [answerForm,setAnswerForm] = useState({
    "title": answer_title,
    "content": ""
  })
  const answerTitleRef = useRef()
  const answerContentRef = useRef()

  const handleSendReply = async () => {
    if (answerForm.title == null || answerForm.title.trim() == "") {
      const confirmed = window.confirm("제목이 비어 있습니다. 그래도 전송하시겠습니까?");
      if (!confirmed) {
        answerTitleRef.current.focus();
        return;
      }
    }
    if (answerForm.content == null || answerForm.content.trim() == "" || answerForm.content.trim().length <= 10) {
      alert("답변 내용을 10글자 이상 작성해 주세요.");
      answerContentRef.current.focus();
    } else {
      await wsApi.sendInquiryReply(inquiry_id, answerForm.title, answerForm.content)
      .then()
      .catch((err) => {
        // console.error("답변 이메일 전송 실패:", err)
      })
      handlePatchStatus();
    }
  }

  return (
    <Box>
      <Typography sx={{ m: 3, fontSize: 32 }}>· 답변 작성</Typography>
      <Box sx={{ m: 3 }}>
        <Box sx={{ display: "flex", gap: 5, my: 3, alignItems: "center" }}>
          <Typography>받는 사람</Typography>
          <Box sx={{ border: "1px solid black", borderRadius: 5, flex: 1, p: 2 }}>
            <TextField 
              variant="standard"
              InputProps={{ disableUnderline: true }}
              fullWidth
              defaultValue={user_email}
              disabled
            />
          </Box>
        </Box>
        <Box sx={{ display: "flex", gap: 5, my: 3, alignItems: "center" }}>
          <Typography>답변 제목</Typography>
          <Box sx={{ border: "1px solid black", borderRadius: 5, flex: 1, p: 2 }}>
            <TextField
              variant="standard"
              InputProps={{ disableUnderline: true }}
              fullWidth
              required
              autoFocus
              minRows={1}
              inputRef={answerTitleRef}
              value={answerForm.title}
              onChange={(e) => setAnswerForm({...answerForm, title: e.target.value})}
            />
          </Box>
        </Box>
        <Box sx={{ display: "flex", gap: 5, my: 3 }}>
          <Typography sx={{ pt: 2.5 }}>답변 내용</Typography>
          <Box sx={{ border: "1px solid black", borderRadius: 5, flex: 1, p: 2 }}>
            <TextField
              variant="standard"
              InputProps={{ disableUnderline: true }}
              fullWidth
              required
              rows={30}
              multiline
              inputRef={answerContentRef}
              value={answerForm.content}
              onChange={(e) => setAnswerForm({...answerForm, content: e.target.value})}
            />
          </Box>
        </Box>
      </Box>
      <Box sx={{ display: "flex", gap: "30px", justifyContent: "center", mt: 10 }}>
        <Button 
          sx={{ 
            backgroundColor: colorPalette.activeBg, 
            color: "#000000",
            width: 200,
            px: 4,
            py: 1.5,
            fontWeight: 450,
            "&:hover": {
              border: "1px solid #000000"
            }
          }}
          onClick={()=> { handleSendReply(); }}
        >
          등록 및 메일 전송
        </Button>
        <Button 
          sx={{ 
            backgroundColor: colorPalette.activeBg, 
            color: "#000000",
            width: 200,
            px: 4,
            py: 1.5,
            fontWeight: 450,
            "&:hover": {
              border: "1px solid #000000"
            }
          }}
          onClick={() => { handlePatchStatus(); }}
        >
          목록
        </Button>
      </Box>
    </Box>
  )
}

export default InquiryAnswer